export default __webpack_public_path__ + "static/media/CEO2.94fe9f48.jpg";